import { IconAudiometria } from './IconAudiometria';
import { IconElectrocardiograma } from './IconElectrocardiograma';
import { IconEspirometria } from './IconEspirometria';
import { IconRayosX } from './IconRayosX';
import { IconUltrasonografia } from './IconUltrasonografia';
import { IconVisiometria } from './IconVisiometria';
import { IconGestionRiesgo } from './IconGestionRiesgo';
import { IconLaboratorioClinico } from './IconLaboratorioClinico';
import { IconMedicionesHigienicas } from './IconMedicionesHigienicas';
import { IconAnalisisinterpretacion } from './IconAnalisisinterpretacion';
import { IconCapacitacionPrevencion } from './IconCapacitacionPrevencion';
import { IconEvaluacionMedica } from './IconEvaluacionMedica';
import { IconExamenesComplementarios } from './IconExamenesComplementarios';
import { IconTomaMuestras } from './IconTomaMuestras';
import { IconOcupacionales } from './IconOcupacionales';
import { IconPostocupacionales } from './IconPostocupacionales';
import { IconPreocupacionales } from './IconPreocupacionales';
import { IconAlimentacion } from './IconAlimentacion';
import { IconDescansos } from './IconDescansos';
import { IconHidratacion } from './IconHidratacion';
import { IconHorarios } from './IconHorarios';
import { IconProteccionSolar } from './IconProteccionSolar';
import { IconRopaAdecuada } from './IconRopaAdecuada';
import { IconDiagnostico } from '../placeholders/IconDiagnostico';
import { IconGrupoTrabajadores } from '../placeholders/IconGrupoTrabajadores';
export const SVG_ICON_REGISTRY = {
    IconAudiometria,
    IconElectrocardiograma,
    IconEspirometria,
    IconRayosX,
    IconUltrasonografia,
    IconVisiometria,
    IconGestionRiesgo,
    IconLaboratorioClinico,
    IconMedicionesHigienicas,
    IconAnalisisinterpretacion,
    IconCapacitacionPrevencion,
    IconEvaluacionMedica,
    IconExamenesComplementarios,
    IconTomaMuestras,
    IconOcupacionales,
    IconPostocupacionales,
    IconPreocupacionales,
    IconAlimentacion,
    IconDescansos,
    IconHidratacion,
    IconHorarios,
    IconProteccionSolar,
    IconRopaAdecuada,
    IconDiagnostico,
    IconGrupoTrabajadores,
};
